import moment from "moment"
import React, { Component } from "react"
import { Row, Col, Button, Table } from "elemental-react16"
import { Icon, Image } from "semantic-ui-react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
import { checkCartSize, checkMinCartValue } from "pages/checkout/check"
import swal from "sweetalert"
import "style/CheckoutPage.scss"
import productStore from "stores/productStore"
import Spinner from "components/Spinner/Spinner"
import SuccessTable from "components/Product/SuccessTable"
import _ from "lodash"

import paypalLogo from "assets/de-pp-logo-200px.png"
import { formatPrice } from "../../../../components/Price/Price";

export default class SuccessPage extends Component {

  state = {
    loading: true,
    bill: false,
    byId: {}
  }

  componentDidMount() {

    let ok = checkCartSize()
    ok = ok && checkMinCartValue()

    if (!ok) {
      this.props.history.replace("/checkout")
      return
    }

    window.setTimeout(this.submit, 5000 + shop.cart.size * 25)
  }

  submit = () => {

    // setup manually
    const extras = {
      delivery_address_id: shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid,
      manual_order_id: shop.cart.getExtra("manual_order_id"),
      referenceId: shop.cart.getExtra("referenceId"),
      is_quotation_request: shop.cart.getExtra("is_quotation_request"),
      attachments: shop.cart.getExtra("attachments"),
      "ts-ordertype": shop.cart.getExtra("is_quotation_request") ? "offer" : null,
      "print_receipt": shop.cart.getExtra("print_receipt"),
    }

    // merge all data
    _.map(shop.cart.data.extras, (value, key) => {
      if (!extras[key]) extras[key] = value
    })

    shop.cart.submit({
      extras
    })
      .then((bill) => {
        this.setState({ bill, loading: false })
        shop.cart.productsById.clear()
        shop.cart.clear()
        shop.cart.update()

        let p = bill.positions.map(position => {
          console.log("loading", position)
          return productStore.get(position.article_id)
        })
        return Promise.all(p)
      })
      .then(products => {
        let byId = {}
        products.forEach(product => {
          byId[product.map_id] = product
        })
        console.log("productStore loaded", byId)

        this.setState({ byId })
      })
      .catch(error => {
        console.error("Checkout Error:", error)
        let errorMessageCreated = false
        try {
          const errComplex = JSON.parse(error.message)
          if (errComplex.addsum && errComplex.rulename === "Budget") {
            swal(translate("Fehler – Budgetüberschreitung"), `${translate("BUDGET_ERROR", { value: formatPrice(errComplex.addsum - errComplex.maxvalue) })}`, "error")
          } else {
            swal(translate("Error"), error, "error")
          }
          errorMessageCreated = true
        }
        catch (err) {
          console.error("ERROR IN CHECKOUT", err)
        }
        if (!errorMessageCreated) {
          swal(translate("Error"), error, "error")
        }
        this.props.history.replace("/checkout/confirmation")
        this.setState({ error })
      })
  }

  render() {
    const { bill, byId, loading } = this.state

    if (loading) {
      return <div className="pa4 tc">
        <Spinner size="md" type="inverted" /></div>
    }

    return <Page bill={bill} byId={byId} />
  }
}

const Page = ({ bill, byId }) => {
  if (!bill) return null
  const order = bill
  const isOffer = order.extras["ts-ordertype"] === "offer"
  return (
    <div className="ui container mw9 ph3 center pt4">
      <section className="billing-tab">
        <img alt={"Firmenlogo"} width={235} className="pt2 pb4" src={shop.config.logo} />

        <h1 className="tl ttu b pb2">{translate("confirmation.title")} {isOffer && "Ihrer Anfrage"}</h1>
        {shop.session.contact &&
          <h2 className="intro-line">
            {isOffer ?
              <span>{translate("confirmation.thanks_request")}</span>
              : <span>{translate("confirmation.thanks_order")}</span>}
          </h2>}

        {isOffer ?
          <p>{translate("confirmation.thanks_request_anonymous")}</p>
          : <p>{translate("confirmation.thanks_order_anonymous")}</p>
        }
        <p>{translate("confirmation.further_question")}<br />
        <a href="mailto:vertrieb@mags-vertrieb.de">E-Mail: vertrieb@mags-vertrieb.de</a><br />
        <a href="tel:07033466680">{translate("Tel.")}: 07033 46668-0</a></p>
      </section>

      <section className="billing-tab pt4">
        <h4>{translate("your data")}</h4>
        <Table className="billing-overview-table">

          <colgroup>
            <col width="25%" />
            <col width="75%" />
          </colgroup>

          <tbody>
            {shop.config.checkoutFeatures.orderNumber && <tr>
              <td>{translate("Order Id")}</td>
              <td className="overview-value">{order.handid}</td>
            </tr>
            }

            {order.extras.manual_order_id &&
              <tr>
                <td>{translate("manual_order_id")}</td>
                <td className="overview-value">{order.extras.referenceId}</td>
              </tr>
            }
            {order.extras.referenceId &&
              <tr>
                <td>{translate("Referenznummer")}</td>
                <td className="overview-value">{order.extras.manual_order_id}</td>
              </tr>
            }

            {shop.config.checkoutFeatures.orderDate &&
              <tr>
                <td>{translate("Bestellzeitpunkt")}</td>
                <td className="overview-value">{moment(order.created).format("HH:mm [Uhr], DD.MMM YYYY")}</td>
              </tr>
            }

            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>

            <tr>
              <td>{translate("Kundennummer")}</td>
              <td className="overview-value">{order.customerid}</td>
            </tr>

            <tr>
              <td>{translate("E-Mail")}</td>
              <td className="overview-value">{order.customer.email || "-"}</td>
            </tr>

            <tr>
              <td>{translate("Telefon")}</td>
              <td className="overview-value">{order.customer.phone || "-"}</td>
            </tr>

          </tbody>
        </Table>
      </section>

      <section className="billing-tab pt4">
        <Row>
          <Col sm="1/2">
            <h4>{translate("Rechnungsadresse")}</h4>
            <p>
              {order.bill.name1} {order.bill.name2} {order.bill.name3} <br />
              {order.bill.street} <br />
              {order.bill.pcode} {order.bill.city} <br />
              {order.bill.country}
            </p>
          </Col>

          <Col sm="1/2">
            <h4>{translate("Lieferadresse")}</h4>
            {order.deliver.name1 ? <p>
              {order.deliver.name1} {order.deliver.name2} {order.deliver.name3} <br />
              {order.deliver.street} <br />
              {order.deliver.pcode} {order.deliver.city} <br />
              {order.deliver.country}
            </p> : <p>
              {order.bill.name1} {order.bill.name2} {order.bill.name3} <br />
              {order.bill.street} <br />
              {order.bill.pcode} {order.bill.city} <br />
              {order.bill.country}
            </p>}
          </Col>
        </Row>
      </section>

      <section className="billing-tab pt4">
        <h2>{isOffer ? <span>{translate("Ihre Anfrage")}</span> : <span>{translate("Ihre Bestellung")}</span>}</h2>
        <SuccessTable showTax={order.extras.payment} positions={order.positions} byId={byId} netto={order.netto} currency={order.currency} />

        {order.extras.payment && <div>
          <h3 className={"mt4"}>{translate("Zahlung")}</h3>
          <div><Image src={paypalLogo} /></div>
        </div>}

        {order.customer.extras.zahlung && <div>
          <h3 className="mt4">{translate("Zahlungsweise")}</h3>
          <p>{order.customer.extras.zahlung}</p>
        </div>}

        {/*<h3 className="mt4">{translate( "your comment" )}</h3>
        <p>{order.comment}</p>*/}

        {order.deliverdate && <div>
          <h3 className="mt4">{translate("Liefertermin (Wunsch)")}</h3>
          <p>{moment(moment(order.deliverdate), "DD.MM.YYYY").format("dddd, DD. MMMM YYYY")}</p>
        </div>}


        {order.extras.attachments && <div>
          <h3 className="mt4">Ihr Anhang</h3>
          <p>{order.extras.attachments}</p>
        </div>}

        {order.extras.print_receipt && <div>
          <h3 className="mt4">{translate("Belegausdruck/Innendienst")}</h3>
          <p>{order.extras.print_receipt}</p>
        </div>}

        {!order.extras.payment && <div className="mt4">
          <p className="b">{translate("confirmation.notice")}</p>
          <p>{translate("confirmation.notice2")}</p>
        </div>}
      </section>

      {shop.config.checkout_thank_you && <div className="pv4">
        <div style={{ whiteSpace: "pre-line" }}>{translate("checkout_thank_you")}</div>
      </div>}

      <section className="text-left pt3 tc">
        <Link to="/"> <Button type="primary"> <Icon name="chevron left" />{translate("zurück zum Shop")}</Button> </Link>
      </section>
      <br />
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/theme/mags/pages/checkout/SuccessPage.js